// src/js/images.js
// Essen slider
import essen1Modern from "../img/essen/essen1.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import essen1Jpg from "../img/essen/essen1.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import essen2Modern from "../img/essen/essen2.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import essen2Jpg from "../img/essen/essen2.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import essen3Modern from "../img/essen/essen3.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import essen3Jpg from "../img/essen/essen3.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import essen4Modern from "../img/essen/essen4.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import essen4Jpg from "../img/essen/essen4.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import essen5Modern from "../img/essen/essen5.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import essen5Jpg from "../img/essen/essen5.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import essen6Modern from "../img/essen/essen6.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import essen6Jpg from "../img/essen/essen6.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import essen7Modern from "../img/essen/essen7.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import essen7Jpg from "../img/essen/essen7.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import essen8Modern from "../img/essen/essen8.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import essen8Jpg from "../img/essen/essen8.jpg?w=800&format=jpg&jpgQuality=60&as=meta";

// Freizeit
import altesbadModern from "../img/freizeit/altesbad.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import altesbadJpg from "../img/freizeit/altesbad.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import kunkelsModern from "../img/freizeit/kunkels.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import kunkelsJpg from "../img/freizeit/kunkels.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import ladestationModern from "../img/freizeit/ladestation.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import ladestationJpg from "../img/freizeit/ladestation.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import mapraggModern from "../img/freizeit/mapragg.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import mapraggJpg from "../img/freizeit/mapragg.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import museumModern from "../img/freizeit/museum.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import museumJpg from "../img/freizeit/museum.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import sagawegModern from "../img/freizeit/sagaweg.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import sagawegJpg from "../img/freizeit/sagaweg.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import stmartinModern from "../img/freizeit/stmartin.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import stmartinJpg from "../img/freizeit/stmartin.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import vaettnerbergModern from "../img/freizeit/vaettnerberg.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import vaettnerbergJpg from "../img/freizeit/vaettnerberg.jpg?w=800&format=jpg&jpgQuality=60&as=meta";

// Headers
import activModern from "../img/headers/activ.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import activJpg from "../img/headers/activ.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import anfahrtModern from "../img/headers/anfahrt.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import anfahrtJpg from "../img/headers/anfahrt.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import gutscheinModern from "../img/headers/gutschein.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import gutscheinJpg from "../img/headers/gutschein.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import jagdModern from "../img/headers/jagd.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import jagdJpg from "../img/headers/jagd.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import restaurantModern from "../img/headers/restaurant.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import restaurantJpg from "../img/headers/restaurant.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import startModern from "../img/headers/start.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import startJpg from "../img/headers/start.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import ueberModern from "../img/headers/ueber.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import ueberJpg from "../img/headers/ueber.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import zimmerModern from "../img/headers/zimmer.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import zimmerJpg from "../img/headers/zimmer.jpg?w=800&format=jpg&jpgQuality=60&as=meta";

// Jagd Slider
import jagd2Modern from "../img/jagd/jagd2.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import jagd2Jpg from "../img/jagd/jagd2.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import jagd3Modern from "../img/jagd/jagd3.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import jagd3Jpg from "../img/jagd/jagd3.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import jagd4Modern from "../img/jagd/jagd4.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import jagd4Jpg from "../img/jagd/jagd4.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import jagd5Modern from "../img/jagd/jagd5.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import jagd5Jpg from "../img/jagd/jagd5.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import jagd6Modern from "../img/jagd/jagd6.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import jagd6Jpg from "../img/jagd/jagd6.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import jagd7Modern from "../img/jagd/jagd7.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import jagd7Jpg from "../img/jagd/jagd7.jpg?w=800&format=jpg&jpgQuality=60&as=meta";

// Portrait
import portraitModern from "../img/portrait/portrait.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import portraitJpg from "../img/portrait/portrait.jpg?w=800&format=jpg&jpgQuality=60&as=meta";

// Restaurant
import bauernstubeModern from "../img/resti/bauernstube.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import bauernstubeJpg from "../img/resti/bauernstube.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import hubertus1Modern from "../img/resti/hubertus1.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import hubertus1Jpg from "../img/resti/hubertus1.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import hubertus2Modern from "../img/resti/hubertus2.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import hubertus2Jpg from "../img/resti/hubertus2.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import speisesaalModern from "../img/resti/speisesaal.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import speisesaalJpg from "../img/resti/speisesaal.jpg?w=800&format=jpg&jpgQuality=60&as=meta";
import stuebliModern from "../img/resti/stuebli.jpg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import stuebliJpg from "../img/resti/stuebli.jpg?w=800&format=jpg&jpgQuality=60&as=meta";

// Zimmer Doppelzimmer Dusche
import do_du1Modern from "../img/zimmer/do_du1.jpeg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import do_du1Jpg from "../img/zimmer/do_du1.jpeg?w=800&format=jpg&jpgQuality=60&as=meta";
import do_du2Modern from "../img/zimmer/do_du2.jpeg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import do_du2Jpg from "../img/zimmer/do_du2.jpeg?w=800&format=jpg&jpgQuality=60&as=meta";
import do_du3Modern from "../img/zimmer/do_du3.jpeg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import do_du3Jpg from "../img/zimmer/do_du3.jpeg?w=800&format=jpg&jpgQuality=60&as=meta";

// Zimmer Einzelzimmer Dusche
import einz_du1Modern from "../img/zimmer/einz_du1.jpeg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import einz_du1Jpg from "../img/zimmer/einz_du1.jpeg?w=800&format=jpg&jpgQuality=60&as=meta";
import einz_du2Modern from "../img/zimmer/einz_du2.jpeg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import einz_du2Jpg from "../img/zimmer/einz_du2.jpeg?w=800&format=jpg&jpgQuality=60&as=meta";

// Zimmer Doppelzimmer Gemeinschaftsbad
import do_gem1Modern from "../img/zimmer/do_gem1.jpeg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import do_gem1Jpg from "../img/zimmer/do_gem1.jpeg?w=800&format=jpg&jpgQuality=60&as=meta";
import do_gem2Modern from "../img/zimmer/do_gem2.jpeg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import do_gem2Jpg from "../img/zimmer/do_gem2.jpeg?w=800&format=jpg&jpgQuality=60&as=meta";
import do_gem3Modern from "../img/zimmer/do_gem3.jpeg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import do_gem3Jpg from "../img/zimmer/do_gem3.jpeg?w=800&format=jpg&jpgQuality=60&as=meta";

// Zimmer Einzelzimmer Gemeinschaftsbad
import einz_gem1Modern from "../img/zimmer/einz_gem1.jpeg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import einz_gem1Jpg from "../img/zimmer/einz_gem1.jpeg?w=800&format=jpg&jpgQuality=60&as=meta";
import einz_gem2Modern from "../img/zimmer/einz_gem2.jpeg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import einz_gem2Jpg from "../img/zimmer/einz_gem2.jpeg?w=800&format=jpg&jpgQuality=60&as=meta";
import einz_gem3Modern from "../img/zimmer/einz_gem3.jpeg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import einz_gem3Jpg from "../img/zimmer/einz_gem3.jpeg?w=800&format=jpg&jpgQuality=60&as=meta";

// Zimmer Vierbettzimmer Gemeinschaftsbad
import vier_gem1Modern from "../img/zimmer/vier_gem1.jpeg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import vier_gem1Jpg from "../img/zimmer/vier_gem1.jpeg?w=800&format=jpg&jpgQuality=60&as=meta";
import vier_gem2Modern from "../img/zimmer/vier_gem2.jpeg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import vier_gem2Jpg from "../img/zimmer/vier_gem2.jpeg?w=800&format=jpg&jpgQuality=60&as=meta";
import vier_gem3Modern from "../img/zimmer/vier_gem3.jpeg?w=400;600;800;1200;1600&format=avif;webp&avifQuality=40&webpQuality=50&effort=4&as=meta";
import vier_gem3Jpg from "../img/zimmer/vier_gem3.jpeg?w=800&format=jpg&jpgQuality=60&as=meta";


/**
 * @typedef {Object} ImageEntry
 * @property {Array} src - imagetools Array
 * @property {string} alt - Alt Text
 * @property {string} [category]
 */

const responsiveImage = (modern, jpg) => [
    ...(Array.isArray(modern) ? modern : [modern]),
    ...(Array.isArray(jpg) ? jpg : [jpg]),
];

// Export
export const images = {
    essen1: {
        src: responsiveImage(essen1Modern, essen1Jpg),
        alt: "Dessertteller mit Cube Bananensplit, frischen Früchten wie Erdbeeren, Himbeeren und Kiwi, einem Waffelstab und einer Schüssel Schokosauce auf einem Metalltablett.",
        category: "essen",
    },
    essen2: {
        src: responsiveImage(essen2Modern, essen2Jpg),
        alt: "Dessertteller mit einer Scheibe Apfelkuchen, einer Kugel Vanilleeis, Sahne, einem Minzblatt und zwei Löffeln auf einem verzierten Teller.",
        category: "essen",
    },
    essen3: {
        src: responsiveImage(essen3Modern, essen3Jpg),
        alt: "Dessertteller mit frischen Beeren (Himbeeren, Brombeeren, Heidelbeeren), Sahne, Waffelstab, Aprikosen, Kiwischeiben, einem Minzblatt und einem Glas mit cremiger Sauce auf einem durchsichtigen Teller.",
        category: "essen",
    },
    essen4: {
        src: responsiveImage(essen4Modern, essen4Jpg),
        alt: "Dessert mit einem Glas cremiger Vanillepudding, bestreut mit Zimt und Schokostreuseln, dazu eine Portion frischer Obstsalat mit Kiwi, Melone, Trauben und Kirschtomaten, garniert mit Sahne und einem Minzblatt.",
        category: "essen",
    },
    essen5: {
        src: responsiveImage(essen5Modern, essen5Jpg),
        alt: "Teller mit goldbraunen Rösti und einer großen Bauernwurst, garniert mit einer kleinen Tomate, Zwiebel und Petersilie.",
        category: "essen",
    },
    essen6: {
        src: responsiveImage(essen6Modern, essen6Jpg),
        alt: "Salatteller mit gemischtem Blattsalat, dünn geschnittenem Rindfleisch, Radieschen, Walnüssen, Käsewürfeln und Sprossen auf einem durchsichtigen Glas-Teller.",
        category: "essen",
    },
    essen7: {
        src: responsiveImage(essen7Modern, essen7Jpg),
        alt: "Vorspeisenteller mit dünn geschnittenem Rindertatar, Parmesanspänen, Petersilie, Tomaten, Gurken, einer Zitronenscheibe, einem halben gekochten Ei, Walnüssen und Gewürzgurken auf einem durchsichtigen Glas-Teller.",
        category: "essen",
    },
    essen8: {
        src: responsiveImage(essen8Modern, essen8Jpg),
        alt: "Großes Buffet mit vielfältigem Fingerfood auf silbernen Tabletts: kleine Sandwiches, Lachs-Häppchen, Mini-Burger, Oliven, Salate in Gläsern sowie Tomaten und Mozzarella.",
        category: "essen",
    },
    // Essen fertig, jetzt Freizeit
    altesbad: {
        src: responsiveImage(altesbadModern, altesbadJpg),
        alt: "Historisches  Gebäude Altes-Bad Pfaefers mit arkadischen Fenstern am Hang",
        category: "freizeit",
    },
    kunkels: {
        src: responsiveImage(kunkelsModern, kunkelsJpg),
        alt: "Idyllische Alpenlandschaft mit grünen Wiesen, einem Holzzaun entlang eines Weges, umringt von dichten Wäldern und majestätischen Bergen unter blauem Himmel mit einigen Wolken.",
        category: "freizeit",
    },
    ladestation: {
        src: responsiveImage(ladestationModern, ladestationJpg),
        alt: "E-Bike-Ladestation mit dem Logo 'bike energy' und Anleitungstext, umgeben von grünen Sträuchern und einem Baumstamm als Veloständer.",
        category: "freizeit",
    },
    mapragg: {
        src: responsiveImage(mapraggModern, mapraggJpg),
        alt: "Wanderweg durch eine Bergschlucht im Wald mit zwei Personen.",
        category: "freizeit",
    },
    museum: {
        src: responsiveImage(museumModern, museumJpg),
        alt: "Traditionelles Haus mit grünen Fensterläden, der Aufschrift 'Gemeindehaus' und 'Museum' sowie einem Wappen über dem Eingang, umgeben von Bergen.",
        category: "freizeit",
    },
    sagaweg: {
        src: responsiveImage(sagawegModern, sagawegJpg),
        alt: "Infotafel mit Fabelfiguren zum Sagaweg Vättis.",
        category: "freizeit",
    },
    stmartin: {
        src: responsiveImage(stmartinModern, stmartinJpg),
        alt: "Blick über den Weiher auf Idyllisches Bergdorf mit Wassermühle, Holzhütten am Teich und das Kirchlein von St. Martin im Hintergrund.",
        category: "freizeit",
    },
    vaettnerberg: {
        src: responsiveImage(vaettnerbergModern, vaettnerbergJpg),
        alt: "Berglandschaft mit Bergstation, die Gondel kurz vor der einfahrt, umgeben von dichten Wäldern und steilen Felswänden.",
        category: "freizeit",
    },
    activ: {
        src: responsiveImage(activModern, activJpg),
        alt: "Gelbes Wanderwegweiseschild mit Richtungsangaben zu Orten wie Valens, Pfäfers und Bad Ragaz, mit einem gerahmten Foto im Vordergrund.",
        category: "freizeit",
    },
    anfahrt: {
        src: responsiveImage(anfahrtModern, anfahrtJpg),
        alt: "Berglandschaft mit Wanderweg Gabelung und grünen Wiesen unter blauem Himmel mit wenig Wolken",
        category: "hero",
    },
    gutschein: {
        src: responsiveImage(gutscheinModern, gutscheinJpg),
        alt: "Festlich dekorierter Restaurantbereich mit elegant gedecktem grossen Tisch und warmem Ambiente.",
        category: "hero",
    },
    jagd: {
        src: responsiveImage(jagdModern, jagdJpg),
        alt: "Grosses Holzschild mit der Aufschrift ‚OSWALD JAGD UND ABENTEUER.",
        category: "hero",
    },
    restaurant: {
        src: responsiveImage(restaurantModern, restaurantJpg),
        alt: "Festlich gedeckter Restauranttisch mit Gläsern und Blumendekoration.",
        category: "hero",
    },
    start: {
        src: responsiveImage(startModern, startJpg),
        alt: "Außenansicht des lachsfarbenen Hotel Tamina mit großer Holzterrasse vor bewaldeter Bergkulisse.",
        category: "hero",
    },
    ueber: {
        src: responsiveImage(ueberModern, ueberJpg),
        alt: "Idyllische Alpenlandschaft mit grünen Wiesen, Nadelbäumen und einer kleinen Hütte vor schneebedeckten Berggipfeln unter blauem Himmel mit einigen Wolken.",
        category: "hero",
    },
    zimmer: {
        src: responsiveImage(zimmerModern, zimmerJpg),
        alt: "Detailansicht eines Hotelbetts mit weißer Bettwäsche, Kopfteil aus Naturholz und einer roten Nachttischlampe.",
        category: "hero",
    },
    jagd2: {
        src: responsiveImage(jagd2Modern, jagd2Jpg),
        alt: "Ausgestopfter Hirsch mit großem Geweih vor einer gemalten Winterlandschaft mit schneebedeckten Bergen und einer Holzhütte.",
        category: "jagd",
    },
    jagd3: {
        src: responsiveImage(jagd3Modern, jagd3Jpg),
        alt: "Nahaufnahme eines ausgestopften Steinbocks mit markanten, gekrümmten Hörnern und einem detaillierten Fell.",
        category: "jagd",
    },
    jagd4: {
        src: responsiveImage(jagd4Modern, jagd4Jpg),
        alt: "Zwei ausgestopfte Auerhühner auf einem natürlichen Untergrund aus Moos und Holz in einer Ausstellung mit Holzwänden.",
        category: "jagd",
    },
    jagd5: {
        src: responsiveImage(jagd5Modern, jagd5Jpg),
        alt: "Ausstellung mit ausgestopften Tieren, darunter zwei Großantilopen mit markanten Hörnern und einer kleinen Antilope im Vordergrund, vor einer gemalten Berglandschaft.",
        category: "jagd",
    },
    jagd6: {
        src: responsiveImage(jagd6Modern, jagd6Jpg),
        alt: "Traditionelle Holzküche mit alten Küchenutensilien wie Kupfer- und Holztöpfen, einer Holzbank, einem Tisch mit Kerzenhalter und historischen Fotos an der Wand.",
        category: "jagd",
    },
    jagd7: {
        src: responsiveImage(jagd7Modern, jagd7Jpg),
        alt: "Ausgestopfter Luchs mit geöffnetem Maul und scharfen Zähnen, der eine Beute hält.",
        category: "jagd",
    },
    portrait: {
        src: responsiveImage(portraitModern, portraitJpg),
        alt: "Porträt von zwei lächelnden Frauen, Yvonne und Sonja, vor dunklem Hintergrund",
        category: "",
    },
    bauernstube: {
        src: responsiveImage(bauernstubeModern, bauernstubeJpg),
        alt: "Festlich gedeckte Tafel in einer rustikalen Bauernstube mit Blumengestecken, Weingläsern und großen Kuhglocken an der Wand",
        category: "restaurant",
    },
    hubertus1: {
        src: responsiveImage(hubertus1Modern, hubertus1Jpg),
        alt: "Großer, festlich gedeckter Speisesaal mit langen Tafeln, grünen Polsterstühlen und einer Wanddekoration aus Geweihen",
        category: "restaurant",
    },
    hubertus2: {
        src: responsiveImage(hubertus2Modern, hubertus2Jpg),
        alt: "Konferenzraum in U-Form bestuhlt mit weiß gedeckten Tischen, Beamer im Vordergrund und Wanddekoration aus Geweihen",
        category: "restaurant",
    },
    speisesaal: {
        src: responsiveImage(speisesaalModern, speisesaalJpg),
        alt: "Gemütlicher Speisesaal mit markanter Holz-Kassettenendecke, hell gedeckten Tischen und rotem Teppichboden",
        category: "restaurant",
    },
    stuebli: {
        src: responsiveImage(stuebliModern, stuebliJpg),
        alt: "Festlich dekorierte Tafel im Taminastübli mit weißen Tischdecken, roten Kerzen und holzverkleideten Wänden",
        category: "restaurant",
    },
    do_du1: {
        src: responsiveImage(do_du1Modern, do_du1Jpg),
        alt: "Helles Schlafzimmer mit zwei Einzelbetten, weißer Bettwäsche, Holzwänden und kleinen Nachttischen",
        category: "zimmer",
    },
    do_du2: {
        src: responsiveImage(do_du2Modern, do_du2Jpg),
        alt: "Gemütliches Schlafzimmer mit Holzvertäfelung, Bett, Sessel und kleinem Fernseher",
        category: "zimmer",
    },
    do_du3: {
        src: responsiveImage(do_du3Modern, do_du3Jpg),
        alt: "Gemütliches Schlafzimmer mit zwei Einzelbetten, Holzverkleidung, Fenster mit Vorhängen und Fernseher",
        category: "zimmer",
    },
    einz_du1: {
        src: responsiveImage(einz_du1Modern, einz_du1Jpg),
        alt: "Ein Hotelzimmer im alpinen Stil mit Holzvertäfelung, einem weiß bezogenen Einzelbett, einem Nachttisch mit Lampe und einem Blick in den hinteren Raum mit Fenster.",
        category: "zimmer",
    },
    einz_du2: {
        src: responsiveImage(einz_du2Modern, einz_du2Jpg),
        alt: "Ein Hotel-Einzelzimmer mit grünem Teppichboden, einem Holzbett mit weißer Bettwäsche, einem Waschbecken im Raum und Blick auf die offene Dusche.",
        category: "zimmer",
    },
    do_gem1: {
        src: responsiveImage(do_gem1Modern, do_gem1Jpg),
        alt: "Ein Hotelzimmer mit zwei zusammengeschobenen Einzelbetten aus hellem Holz, bezogen mit weißer Bettwäsche, vor zwei Fenstern mit gemusterten Vorhängen.",
        category: "zimmer",
    },
    do_gem2: {
        src: responsiveImage(do_gem2Modern, do_gem2Jpg),
        alt: "Ein gemütliches Schlafzimmer mit zwei nebeneinanderstehenden Betten vor einer holzgetäfelten Wand, bezogen mit weißer Bettwäsche mit dezentem Muster, flankiert von zwei Nachttischen mit roten Tischlampen.",
        category: "zimmer",
    },
    do_gem3: {
        src: responsiveImage(do_gem3Modern, do_gem3Jpg),
        alt: "Rustikales Hotelzimmer mit Holzverkleidung, zwei Betten im Vordergrund, einem kleinen Tisch mit Stuhl und einem Waschbecken an einer blauen Wandnische im Hintergrund.",
        category: "zimmer",
    },
    einz_gem1: {
        src: responsiveImage(einz_gem1Modern, einz_gem1Jpg),
        alt: "Ein einfach eingerichtetes Einzelzimmer mit einem Holzbett mit weißer Bettwäsche an einer weißen Wand, einem kleinen Nachttisch und einem Fenster mit gemusterten Vorhängen.",
        category: "zimmer",
    },
    einz_gem2: {
        src: responsiveImage(einz_gem2Modern, einz_gem2Jpg),
        alt: "Ein helles Einzelzimmer mit einem massiven Holzbett, weißer Bettwäsche mit dezentem Muster und einem Fenster mit Vorhängen im Hintergrund.",
        category: "zimmer",
    },
    einz_gem3: {
        src: responsiveImage(einz_gem3Modern, einz_gem3Jpg),
        alt: "Nahaufnahme eines hölzernen Nachttischs mit einer roten Dekoration und einem Radio vor einem weiß bezogenen Bett mit Holzrückwand.",
        category: "zimmer",
    },
    vier_gem1: {
        src: responsiveImage(vier_gem1Modern, vier_gem1Jpg),
        alt: "Ein geräumiges Vierbettzimmer mit zwei Betten im Vordergrund, einem Sofa, einem weiteren Bett an der Wand, einem Couchtisch auf einem Orientteppich und einer Waschbecken-Nische im Hintergrund.",
        category: "zimmer",
    },
    vier_gem2: {
        src: responsiveImage(vier_gem2Modern, vier_gem2Jpg),
        alt: "Ein helles Familienzimmer mit Holzboden, einem gestreiften Sofa, einem Einzelbett an der Wand, einem Couchtisch auf einem Orientteppich und Blick durch eine offene Tür in einen Raum mit einem weiteren Bett.",
        category: "zimmer",
    },
    vier_gem3: {
        src: responsiveImage(vier_gem3Modern, vier_gem3Jpg),
        alt: "Ein geräumiges Hotelzimmer mit zwei zusammengeschobenen Einzelbetten aus Holz, einem gestreiften Sofa an der Wand, einem kleinen Couchtisch auf einem Orientteppich und hellen Fenstern mit gemusterten Vorhängen.",
        category: "zimmer",
    }
};
